<template>
  <basic-container>
    <avue-crud :option="option" v-model:search="search" v-model="form" :data="data" ref="crud" :page.sync="page"
      @refresh-change="onLoad" @on-load="onLoad">
    </avue-crud>
  </basic-container>
</template>

<script>
import { create } from 'js-md5';
import {
  getPageListApi,
  getElderlyListApi
} from '../api/mandateManage';
export default {
  props: {
    row: {
      default: {},
    }
  },
  data() {
    return {
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '老人',
            prop: 'elderlyId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            dataType: 'string',
          },
          {
            label: '嘱托事件',
            prop: 'entrustEvent',
          },
          {
            label: '嘱托时间',
            prop: 'entrustTime',
          },
          {
            label: '描述',
            prop: 'description',
            type: 'textarea',
            span: 24,
            maxlength: '200',
            minRows: 3,
            maxRows: 5,
            showWordLimit: true,
          },
        ],
      },
      data: []
    };
  },

  create() {
    this.init()
  },

  methods: {
    initData() {
      getElderlyListApi({
      id: this.row.nursinghomeId,
    })
      .then(({ data }) => {
        if (data.length > 0) {
          this.findObject(this.option.column, 'elderlyId').dicData = data;
          this.onLoad();
        }
      })
      .catch(() => {
      });
    },
    onLoad() {
      this.loading = true;
      getPageListApi(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize, nursinghomeId: this.row.nursinghomeId, elderlyId: this.row.id }
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<style></style>
